"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NoPatientsNotification = _interopRequireDefault(require("./NoPatientsNotification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _NoPatientsNotification.default;
exports.default = _default;